// src/routes/AppRoutes.tsx
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

// Layout
import MainLayout from "../layouts/MainLayout";
import Login from "../pages/auth/Login/index";
import Dashboard from "../pages/Results";
import NetworkAnalysis from "../pages/networkAnalysis";
import MyExam from "../pages/myexam";
import Schedule from "../pages/Schedule";
import Invigilation from "../pages/Invigilation";
import Evaluation from "../pages/Evaluation";
import Enrollment from "../pages/myexam/Enrollment";
import MarksBreakdown from "../pages/Results/MarksBreakdown";
import GradeCard from "../pages/Results/GradeCard";
import FacultyExams from "../pages/FacultyExams";
import EvaluatioRequests from "../pages/EvaluationRequests";
import EvaluationDetails from "../pages/EvaluationDetails";
import MarksEvaluation from "../pages/MarksEvaluation";

const PrivateRoute = ({
  children,
  role,
}: {
  children: any;
  role: "Faculty" | "Student";
}) => {
  const { role: userRole, initializing } = useAuth();
  if (initializing) return null;
  if (!userRole) return <Navigate to="/login" replace />;
  if (userRole !== role) return <Navigate to="/login" replace />;
  return children;
};

const RedirectIfAuthenticated = ({ children }: { children: any }) => {
  const { role, initializing } = useAuth();
  if (initializing) return null;
  if (role === "Faculty") return <Navigate to="/faculty/facultyExams" replace />;
  if (role === "Student") return <Navigate to="/student/myexam" replace />;
  return children;
};

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Auth Routes */}
        <Route
          path="/login"
          element={
            <RedirectIfAuthenticated>
              <Login />
            </RedirectIfAuthenticated>
          }
        />
        {/* Faculty Routes */}
        <Route
          path="/faculty"
          element={
            <PrivateRoute role="Faculty">
              <MainLayout />
            </PrivateRoute>
          }
        >
          <Route path="facultyExams" element={<FacultyExams />} />
          <Route path="invigilation" element={<Invigilation />} />
          <Route path="evaluation" element={<Evaluation />} />
          <Route path="evaluationRequests" element={<EvaluatioRequests />} />
          <Route path="evaluationDetails" element={<EvaluationDetails />} />
          <Route path="markEvaluation" element={<MarksEvaluation/>} />

        </Route>

        {/* Student Routes */}
        <Route
          path="/student"
          element={
            <PrivateRoute role="Student">
              <MainLayout />
            </PrivateRoute>
          }
        >
          <Route path="result" element={<Dashboard />} />
          <Route path="networkAnalysis" element={<NetworkAnalysis />} />
          <Route path="myexam" element={<MyExam />} />
          <Route path="schedule" element={<Schedule />} />
          <Route path="enrollment" element={<Enrollment />} />
          <Route path="gradeCard" element={<GradeCard />} />
          <Route path="marksBreakdown" element={<MarksBreakdown />} />
          <Route path="*" element={<Navigate to="result" />} />
        </Route>

        {/* Default redirect */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}
